import { useEffect } from 'react';

export function usePrivacyScrollLock(open: boolean) {
    useEffect(() => {
        if (!open) return;
        const wrapper = document.querySelector(
            '.privacy-scrollable-wrapper'
        ) as HTMLElement | null;
        if (!wrapper) return;

        // lock page scroll
        document.body.style.overflow = 'hidden';
        const html = document.documentElement;
        const prevOverflow = html.style.overflow;
        html.style.overflow = 'hidden';

        const handleWheel = (e: WheelEvent) => {
            const { scrollTop, scrollHeight, clientHeight } = wrapper;
            const atTop = scrollTop === 0;
            const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
            if (
                (e.deltaY < 0 && atTop) ||
                (e.deltaY > 0 && atBottom)
            ) {
                e.preventDefault();
            }
        };

        const preventTouch = (e: TouchEvent) => {
            if (!wrapper.contains(e.target as Node)) {
                e.preventDefault();
            }
        };

        const preventKeys = (e: KeyboardEvent) => {
            if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', ' '].includes(e.key)) {
                e.preventDefault();
            }
        };

        wrapper.addEventListener('wheel', handleWheel, { passive: false });
        document.addEventListener('touchmove', preventTouch, { passive: false });
        document.addEventListener('keydown', preventKeys);

        return () => {
            document.body.style.overflow = 'auto';
            html.style.overflow = prevOverflow;
            wrapper.removeEventListener('wheel', handleWheel);
            document.removeEventListener('touchmove', preventTouch);
            document.removeEventListener('keydown', preventKeys);
        };
    }, [open]);
}
